const logger = {}

logger.log = (msg) => {
    console.log(msg)
}

export default logger